import { render, staticRenderFns } from "./Markettt.vue?vue&type=template&id=4395ba49&scoped=true&"
import script from "./Markettt.vue?vue&type=script&lang=js&"
export * from "./Markettt.vue?vue&type=script&lang=js&"
import style0 from "./Markettt.vue?vue&type=style&index=0&id=4395ba49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4395ba49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCard,VDivider,VSpacer,VSubheader})
